import { Component, Prop, State, Event, EventEmitter, h } from '@stencil/core';
import { isRtl } from '@ugc-utils/utils';
import { ErrorIcon } from '../../icons';

@Component({
  tag: 'ugc-textarea',
  styleUrl: 'ugc-textarea.scss',
  shadow: false,
})
export class UgcTextarea {
  @Prop() textareaName: string = 'textareaName';
  @Prop() textareaValue: string = '';
  @Prop() errorMessage: string = '';
  @Prop() isError: boolean = false;
  @Prop() isShowErrorIcon: boolean = true;
  @Prop() height: number = 0;
  @Prop() disabled: boolean = false;

  @State() isOpen: boolean = false;

  @Event() inputChange: EventEmitter;

  textareaElement!: HTMLTextAreaElement;

  handleInputClick() {
    this.isOpen = true;
  }

  handleInputBlur() {
    this.isOpen = false;
  }

  handleInput({ target: { value = '' } }) {
    this.inputChange.emit(value);
  }

  renderErrorNotice() {
    return (
      this.isError &&
      this.errorMessage !== '' && (
        <div class="flex-row-start-center" style={{ marginTop: '6px' }}>
          {this.isShowErrorIcon && <ErrorIcon width="16" height="16" fill="#bd3c37" />}
          <span class="fs-12" style={{ margin: isRtl() ? '0 6px 0 0' : '0 0 0 6px', color: '#bd3c37' }}>
            {this.errorMessage}
          </span>
        </div>
      )
    );
  }

  renderTextarea() {
    return (
      <div class={{ 'ugc-textarea-wrap': true, active: this.isOpen, error: this.isError }}>
        <textarea
          ref={el => (this.textareaElement = el as HTMLTextAreaElement)}
          id={this.textareaName}
          class="fs-16 pointer bg-white"
          style={{ height: `${this.height}px` }}
          value={this.textareaValue}
          disabled={this.disabled}
          onInput={this.handleInput.bind(this)}
          onClick={this.handleInputClick.bind(this)}
          onBlur={this.handleInputBlur.bind(this)}
        />
        <label
          htmlFor={this.textareaName}
          class={{ 'fs-14': true, pointer: true, 'active-label': this.textareaValue !== '' }}
        >
          {this.textareaName}
        </label>
      </div>
    );
  }

  render() {
    return [this.renderTextarea(), this.renderErrorNotice()];
  }
}
